import { render, staticRenderFns } from "./BCXSidebarAsLayer.vue?vue&type=template&id=9d77b938"
import script from "./BCXSidebarAsLayer.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXSidebarAsLayer.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports